import "./ss-header-search.css";
import { initSearchSpringAccessibility } from "../utils/searchspring-accessibility.js";

export default () => {
  const handleAddToCart = async (e) => {
    e.preventDefault();

    // Grab data attributes from the clicked "Add to Cart" button
    const button = e.target;
    const productID = button.getAttribute('product-id');
    const productHandle = button.getAttribute('product-handle');

    if (!productID || !productHandle) {
      console.error("Missing product-id or product-handle attribute on button.");
      return;
    }

    try {
      // 1) Always fetch the product JSON (including any bundle info)
      const response = await fetch(`/products/${productHandle}?section_id=product`);
      const html = await response.text();

      // 2) Parse HTML to find <script data-section-data> and read the JSON
      const dom = new DOMParser().parseFromString(html, 'text/html');
      const markup = dom.querySelector('[data-section-data]');
      if (!markup) {
        console.error("No [data-section-data] element found; cannot determine bundle info.");
        return;
      }

      const sectionData = JSON.parse(markup.innerText);

      // 3) Find the matching variant in the fetched product data
      const currentVariant = sectionData?.variants?.find(
        (v) => v.variantId.toString() === productID.toString()
      );
      if (!currentVariant) {
        console.error("No matching variant found in fetched data.");
        return;
      }

      // 4) If it's a bundle, override the merchandiseId with the first variant's ID
      //    (matching PDP logic: currentVariant.variantBundle.variants[0].id)
      let merchandiseId = `gid://shopify/ProductVariant/${productID}`; // default

      if (currentVariant?.variantBundle?.variants?.length) {
        const bundleDefaultVariantId = currentVariant.variantBundle.variants[0].id;
        merchandiseId = `gid://shopify/ProductVariant/${bundleDefaultVariantId}`;
      }

      // 5) Dispatch the "cart:add" event with the final merchandiseId
      const addToCartEvent = new CustomEvent('cart:add', {
        detail: {
          payload: {
            merchandiseId,
            quantity: 1,
          },
        },
      });
      document.dispatchEvent(addToCartEvent);

    } catch (error) {
      console.error("Error fetching or processing product data:", error);
    }
  };

  const init = () => {
    const attachATC = () => {
      const container = document.querySelector('.ss__results');
      if (container) {
        // For each product card in the .ss__results container
        const articles = Array.from(container.querySelectorAll('[data-product="article"]'));
        articles.forEach((article) => {
          const formButton = article.querySelector('button[type="submit"]');
          if (formButton) {
            formButton.removeEventListener('click', handleAddToCart, true);
            formButton.addEventListener('click', handleAddToCart, true);
          }
        });
      }
    };

    // Attach Add to Cart once Searchspring DOM is ready
    document.addEventListener('searchSpringDomReady', attachATC);
    // Fix SearchSpring accessibility
    document.addEventListener('searchSpringDomReady', initSearchSpringAccessibility);

    // Clear search input each time the panel opens
    document.addEventListener('search:open', () => {
      const searchFormInput = document.querySelector('[data-section="ss-header-search"] form input');
      if (searchFormInput) {
        searchFormInput.value = "";
      }
    });

    // Auto-focus the search input on open
    const handleSearchOpen = () => {
      const searchPanel = document.querySelector('[data-section="ss-header-search"]');
      const searchInput = searchPanel?.querySelector('.ss-autocomplete');
      if (searchPanel && searchInput) {
        searchInput.focus();
      }
    };

    document.addEventListener('search:open', handleSearchOpen);
  };

  init();
};

export const searchSlideout = () => {
  const overlayClasses = {
    open: 'w-full h-full fixed left-0 top-0 z-50 bg-black/60',
    close: 'duration-[800ms] fixed top-0 h-full fixed opacity-0 z-50',
  };

  const contentClasses = {
    open: 'pointer-events-all block max-w-panel w-full h-full fixed top-0 bottom-0 transition-transform z-50 bg-white right-0 translate-x-0 opacity-100 !max-w-[440px] overflow-x-auto px-4 py-2',
    close:
      'pointer-events-none block max-w-panel w-full h-full fixed top-0 bottom-0 transition-transform z-50 bg-white right-0 translate-x-full !max-w-[440px] overflow-x-auto px-4 py-2',
  };

  const searchButtonSelector = '[data-search-trigger]';
  const mobileSearchButtonSelector = '#header-portal [data-header="nav"] button';
  const componentSelector = '[data-section="ss-header-search"]';
  const overlaySelector = '#ss-search-overlay';
  const contentSelector = '#ss-search-slideout';
  const closeButtonSelector = '#ss-search-close';

  const open = (component, overlay, content) => {
    component.setAttribute('data-open', true);
    overlay?.setAttribute('class', overlayClasses.open);
    content?.setAttribute('class', contentClasses.open);
    document.body.style.overflow = 'hidden';
  };

  const close = (component, overlay, content) => {
    component.removeAttribute('data-open');
    overlay?.setAttribute('class', overlayClasses.close);
    content?.setAttribute('class', contentClasses.close);
    document.body.style.overflow = null;
  };

  const bindEvents = () => {
    const component = document.querySelector(componentSelector);
    const searchButton = document.querySelector(searchButtonSelector);
    const mobileSearchButton = document.querySelector(mobileSearchButtonSelector);
    const overlay = document.querySelector(overlaySelector);
    const content = document.querySelector(contentSelector);
    const closeBtn = document.querySelector(closeButtonSelector);

    if (!component || !searchButton || !overlay || !content || !closeBtn || !mobileSearchButton) {
      return;
    }

    searchButton.addEventListener('click', () => {
      const isOpen = component.getAttribute('data-open');
      if (isOpen) {
        close(component, overlay, content);
      } else {
        open(component, overlay, content);
      }
    });

    mobileSearchButton.addEventListener('click', () => {
      open(component, overlay, content);
    });

    overlay.addEventListener('click', (e) => {
      if (!content.contains(e.target)) {
        close(component, overlay, content);
      }
    });

    closeBtn.addEventListener('click', () => {
      close(component, overlay, content);
    });
  };

  window.addEventListener('load', () => bindEvents());

  return {
    bindEvents,
    open,
    close,
  };
};

searchSlideout();
